import { CareTeamRole } from '@summer-health/types/care-team';

export enum CarePlanItemType {
  READING = 'READING',
  CHAT_REQUEST = 'CHAT_REQUEST',
  MILESTONE = 'MILESTONE',
}

export enum CarePlanItemTriggerType {
  SIGNUP = 'SIGNUP',
  AGE = 'AGE',
  TIME_OF_YEAR = 'TIME_OF_YEAR',
  LOCATION = 'LOCATION',
}

export enum CarePlanOpenLinkBehavior {
  SELF = 'SELF',
  NEW = 'NEW',
}

export enum CarePlanBirthSex {
  MALE = 'MALE',
  FEMALE = 'FEMALE',
  ANY = 'ANY',
}

export interface CarePlanItemTag {
  icon: string;
  label: string;
}

export interface CarePlanItem {
  carePlanItemId: string;
  type: CarePlanItemType;
  overline: string;
  title: string;
  blurb?: string;
  primaryCTA: string;
  triggerType: CarePlanItemTriggerType;
  triggerValueInDays: number;
  birthSex?: CarePlanBirthSex;
  careTeamRole?: CareTeamRole;
  tags?: CarePlanItemTag[];
}

export interface CarePlanMilestone extends CarePlanItem {
  primaryCTAURL: string;
}

export interface CarePlanReading extends CarePlanItem {
  primaryCTAURL: string;
  openLinkBehavior: CarePlanOpenLinkBehavior;
  icon: string;
}

export interface CarePlanChatRequest extends CarePlanItem {
  specifiedProviderId?: string;
}
